module.exports = __webpack_public_path__ + "static/media/16.e2f4cf1a.jpg";